import React from 'react';
import {
    Link
} from 'react-router-dom';

import styled from 'styled-components';

import HeaderUno from '../Compartidos/HeaderUno';
import HeaderMetodos from '../../AuxiliaresPaginas/HeaderMetodos';

import {
    HrMetodos
} from '../../Css/StyledHeader';


// =============================================================================
// CONTENEDOR GENERAL
// =============================================================================

const PantallaFraccionesMenu = styled.div`

    width: 100%;

    height: 100vh;

    display: flex;

    flex-direction: column;

    box-sizing: border-box;

    overflow: hidden;

    background-color: #FFFFFF;
`;


// =============================================================================
// HEADER
// =============================================================================

const HeaderFraccionesMenu = styled.div`

    flex-shrink: 0;
`;


// =============================================================================
// CONTENIDO
// =============================================================================

const ContenidoFraccionesMenu = styled.div`

    width: 100%;

    flex: 1;

    min-height: 0;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    padding:
        clamp(
            12px,
            2.2vh,
            28px
        )
        clamp(
            20px,
            4vw,
            60px
        );

    overflow: hidden;


    @media (max-height: 720px) {

        padding:
            10px
            25px;
    }


    @media (max-height: 600px) {

        padding:
            6px
            20px;
    }
`;


// =============================================================================
// GRILLA
// =============================================================================

const GrillaFracciones = styled.div`

    width: 100%;

    max-width: 1050px;

    display: grid;

    grid-template-columns:
        repeat(
            3,
            minmax(
                0,
                1fr
            )
        );

    justify-items: center;

    align-items: start;

    gap:
        clamp(
            8px,
            2vh,
            28px
        )
        clamp(
            22px,
            4vw,
            60px
        );


    @media (max-width: 720px) {

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        overflow-y: auto;

        padding-bottom: 20px;
    }


    @media (max-width: 480px) {

        grid-template-columns:
            1fr;
    }
`;


// =============================================================================
// TARJETA
// =============================================================================

const TarjetaFraccion = styled(Link)`

    /*
    En pantallas altas llega hasta 280px.

    En pantallas bajas se achica automáticamente
    según la altura disponible.
    */

    width:
        min(
            100%,
            clamp(
                165px,
                32vh,
                280px
            )
        );

    display: flex;

    flex-direction: column;

    justify-content: flex-start;

    align-items: center;

    gap:
        clamp(
            3px,
            0.8vh,
            9px
        );

    text-decoration: none;

    color: #111111;

    font-family: 'Nunito';

    font-size:
        clamp(
            0.72rem,
            1.7vh,
            1.08rem
        );

    font-weight: 800;

    line-height: 1.15;

    text-align: center;

    cursor: pointer;


    img {

        width: 100%;

        aspect-ratio:
            16 / 10;

        display: block;

        object-fit: contain;

        box-sizing: border-box;

        background-color:
            #FFFFFF;

        border:
            2px solid
            #23AAAF;

        border-radius:
            12px;

        box-shadow:
            0 4px 6px
            rgba(
                0,
                0,
                0,
                0.22
            );

        transition:
            transform
            0.18s ease,
            box-shadow
            0.18s ease;
    }


    span {

        color:
            #111111;

        text-transform:
            uppercase;

        text-shadow:
            1px 1px 2px
            rgba(
                0,
                0,
                0,
                0.16
            );
    }


    &:hover img {

        transform:
            translateY(-3px);

        box-shadow:
            0 7px 11px
            rgba(
                0,
                0,
                0,
                0.24
            );
    }


    &:active img {

        transform:
            translateY(1px);
    }
`;


// =============================================================================
// DATOS
// =============================================================================

const ejercicios = [

    {
        codigo: 'M150',
        titulo: 'Fracciones en la recta numérica'
    },

    {
        codigo: 'M151',
        titulo: 'Fracciones en situaciones'
    },

    {
        codigo: 'M152',
        titulo: 'Reparto en partes iguales'
    },

    {
        codigo: 'M153',
        titulo: 'Problemas con fracciones'
    },

    {
        codigo: 'M154',
        titulo: 'Representar fracciones'
    },

    {
        codigo: 'M155',
        titulo: 'Fracciones y números mixtos'
    },

    {
        codigo: 'M156',
        titulo: 'Comparar fracciones'
    },

    {
        codigo: 'M157',
        titulo: 'Completar el entero'
    },

    {
        codigo: 'M158',
        titulo: 'Repartir varios enteros'
    }

];


// =============================================================================
// COMPONENTE
// =============================================================================

const Fracciones = () => {

    return (

        <PantallaFraccionesMenu>


            {/* ============================================================= */}
            {/* HEADER                                                        */}
            {/* ============================================================= */}

            <HeaderFraccionesMenu>


                <HeaderUno />


                <HrMetodos
                    margin='0 0.2rem 0.5rem 0.2rem'
                />


                <HeaderMetodos

                    l1={"metodos/"}

                    l2={"matematica/"}

                    n1={"Métodos"}

                    n2={"MATEMATICA"}

                    componente={"FRACCIONES"}

                    paciente={true}

                    bgcolor="#23AAAF"

                    color="white"

                    width='96vw'

                    shadow="0px 4px 4px rgba(0, 0, 0, 0.25)"

                    display="none"

                />


            </HeaderFraccionesMenu>


            {/* ============================================================= */}
            {/* TARJETAS                                                      */}
            {/* ============================================================= */}

            <ContenidoFraccionesMenu>


                <GrillaFracciones>


                    {
                        ejercicios.map(
                            ejercicio => (

                                <TarjetaFraccion

                                    key={
                                        ejercicio.codigo
                                    }

                                    to={
                                        `/escritorio/metodos/matematica/fracciones/${ejercicio.codigo}`
                                    }

                                >

                                    <img

                                        src={
                                            `/img/portadas/${ejercicio.codigo}.png`
                                        }

                                        alt=""

                                    />


                                    <span>

                                        {
                                            ejercicio.titulo
                                        }

                                    </span>


                                </TarjetaFraccion>

                            )
                        )
                    }


                </GrillaFracciones>


            </ContenidoFraccionesMenu>


        </PantallaFraccionesMenu>
    );
};


export default Fracciones;